import { combineReducers } from 'redux';
import { userReducer as userPage } from './../api/user/userReducer';
import { categoryReducer as categoryPage } from './../api/category/categoryReducer';
import { productReducer as productPage } from './../api/product/productReducer';
import { cartReducer as cartPage } from './../api/cart/cartReducer';
import { affiliateReducer as affiliatePage } from './../api/affiliate/affiliateReducer';
import { contactReducer as contactPage } from './../api/contact/contactReducer';
import { orderReducer as orderPage } from './../api/order/orderReducer';
import { galleryReducer as galleryPage } from './../api/gallery/galleryReducer';
import { cmsReducer as cmsPage } from './../api/cms/cmsReducer';
import { withdrawalReducer as withdrawalPage } from './../api/withdrawal/withdrawalReducer';

const appReducer = combineReducers({
    userPage,
    categoryPage,
    productPage,
    cartPage,
    affiliatePage,
    contactPage,
    orderPage,
    galleryPage,
    cmsPage,
    withdrawalPage
});

export default appReducer;